var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVesionSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0027 18.0005C23.6418 17.8595 14.9946 23.7024 9.55829 29.6864C8.98766 30.3199 8.67188 31.1423 8.67188 31.9949C8.67188 32.8475 8.98766 33.67 9.55829 34.3035C14.8764 40.1609 23.4987 46.1386 32.0027 45.9955C40.5067 46.1386 49.1311 40.1609 54.4533 34.3035C55.024 33.67 55.3398 32.8475 55.3398 31.9949C55.3398 31.1423 55.024 30.3199 54.4533 29.6864C49.0108 23.7024 40.3636 17.8595 32.0027 18.0005Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M39.7788 31.9989C39.7784 33.5372 39.3219 35.0408 38.467 36.3197C37.612 37.5985 36.3971 38.5951 34.9758 39.1835C33.5545 39.7719 31.9907 39.9256 30.482 39.6253C28.9734 39.3249 27.5876 38.584 26.5001 37.4961C25.4125 36.4082 24.6719 35.0223 24.372 33.5135C24.072 32.0048 24.2262 30.441 24.8149 29.0198C25.4037 27.5987 26.4006 26.384 27.6797 25.5295C28.9587 24.6749 30.4625 24.2188 32.0007 24.2188C33.0224 24.2185 34.0341 24.4195 34.9781 24.8105C35.922 25.2014 36.7797 25.7745 37.502 26.497C38.2243 27.2196 38.7972 28.0774 39.1879 29.0214C39.5786 29.9655 39.7794 30.9773 39.7788 31.9989Z",
    stroke: "#6263AB",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesionSvg);
export default __webpack_public_path__ + "static/media/vesionSVG.2d5ad7db0404b892e9b066aaf194339f.svg";
export { ForwardRef as ReactComponent };